import axios from "axios";

axios.defaults.baseURL = 'https://medreminder.herokuapp.com';
// axios.defaults.baseURL = 'https://med-reminder-service.herokuapp.com';

axios.defaults.headers.common['Authorization'] = localStorage.getItem('token');